import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, HashRouter } from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from './App';

import AuthCallback from './service/auth_callback';
import {syncTelemetryContextFromLocation} from './helpers/newrelic';
console.log("route:", window.location.pathname);

if (window.location.pathname === '/login_callback' || window.location.pathname === '/catchup/login_callback') {
  const queryString = window.location.search;
  window.location.replace(`/#/login_callback${queryString}`);
} else {
  syncTelemetryContextFromLocation();
  ReactDOM.render(
    <HashRouter basename="catchup">
      <App />
    </HashRouter>,
    document.getElementById('root')
  );
}